import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MinutesOfMeeting from './minutesOfMeeting';
import { createMom } from 'services/redux/brandActivtion/conductCamp/action';
import { getMeetingById } from 'services/redux/brandActivtion/conductCamp/action';

const mapStateToProps = (state) => ({
  meetingById: state.ConductCampReducer.meetingById,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createMom, getMeetingById }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MinutesOfMeeting);
